import { useState } from 'react';
import { Grid, Typography, Button } from '@mui/material';

import { useSelector } from 'react-redux';
import DateRangeIcon from '@mui/icons-material/DateRange';

import { formatDateOnlyNumbers } from '@shared/helpers/formatDate';
import { convertToCamelCase } from '@shared/helpers';
import rawGetFormattedPrice from '@shared/helpers/rawGetFormattedPrice';
import { CustomDialogModal, InfoDialogModal } from '@shared/components/Dialogs';

import FormCheckAvailavility from '../../FormCheckAvailavility';

const PricesHotelDetail = ({ details, search }) => {
  const [showModal, setShowModal] = useState(false);
  const [messageModal, setMessageModal] = useState(false);

  const { business_types } = useSelector(store => store.pageConfiguration);
  const isB2B = +business_types?.id === 2;
  const amountText = isB2B ? 'Neto total ' : 'Precio total ';

  const rate = details.rate?.[0];
  const room = rate?.rooms?.[0];
  const isAvailable = room?.availability !== 'ORQ';

  const renderPriceInfo = () => (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mt: '2vh',
        mb: { xs: '2vh', sm: 0 },
        alignItems: 'center',
      }}
    >
      <Typography sx={{ color: 'black', fontSize: 22, fontWeight: 700 }}>
        Precio por noche
      </Typography>

      <Typography
        sx={{ color: '#FF2020', fontSize: 22, fontWeight: 700, my: 1 }}
      >
        {rawGetFormattedPrice({
          price: rate?.price,
          business_types,
          showPriceByNight: true,
        })}
      </Typography>

      <Typography sx={{ color: '#636466', fontSize: 14 }}>
        {amountText}
        {rawGetFormattedPrice({ price: rate?.price, business_types })}
      </Typography>

      {+rate.price.details.charges === 0 && (
        <Typography
          sx={{ color: '#000', fontSize: 14, textAlign: 'center', mt: 1 }}
        >
          No incluye gastos administrativos.
        </Typography>
      )}

      <Typography sx={{ color: '#000', fontSize: 14, mt: 1 }}>
        {`${search.totalNights} ${
          search.totalNights === 1 ? 'noche' : 'noches'
        }, ${search.totalPassengers} ${
          search.totalPassengers === 1 ? 'huésped' : 'huéspedes'
        }`}
      </Typography>

      <Typography sx={{ mt: 1, textAlign: 'center' }}>
        {convertToCamelCase(rate.board.description)}
      </Typography>
    </Grid>
  );

  const renderUnavailable = () => (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: '3vh',
      }}
    >
      <Button
        sx={{ mt: 1, fontSize: 13, textTransform: 'none', borderRadius: 2 }}
        color="primary"
        onClick={() => setShowModal(true)}
      >
        Consultanos
      </Button>
    </Grid>
  );

  const renderDateRow = (label, date) => (
    <Grid
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 0.5,
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 400, textAlign: 'start' }}>
        {label}
      </Typography>
      <DateRangeIcon sx={{ mx: 0.5 }} />
      <Typography sx={{ fontSize: 16, fontWeight: 400 }}>
        {formatDateOnlyNumbers(date)}
      </Typography>
    </Grid>
  );

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      sx={{ minHeight: 200, width: '100%', px: 1 }}
    >
      {isAvailable ? renderPriceInfo() : renderUnavailable()}

      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 600,
          color: '#000',
          textAlign: 'center',
          mb: 1,
          mt: 2,
        }}
      >
        Fechas seleccionadas
      </Typography>

      {renderDateRow('Desde', search.checkIn)}
      {renderDateRow('Hasta', search.checkOut)}

      {showModal && (
        <CustomDialogModal open={showModal} onClose={() => setShowModal(false)}>
          <FormCheckAvailavility
            closeModalHandler={setShowModal}
            showMessage={setMessageModal}
          />
        </CustomDialogModal>
      )}

      {messageModal && (
        <InfoDialogModal
          isOpen={messageModal}
          onClose={() => setMessageModal(false)}
          title="Consulta de alojamiento"
          text="Gracias por su consulta, en breve nos contactaremos con usted"
        />
      )}
    </Grid>
  );
};

export default PricesHotelDetail;
